module.exports = __webpack_public_path__ + "static/media/endows_android.bc8857af.png";